import Blog1 from "../images/blog1.jpg";
import Blog2 from "../images/blog2.jpg";
import Blog3 from "../images/blog3.jpg";

export const Blogs = [
  {
    image: Blog2,
    name: "The influence of John Locke on the modified agile approach in contrast to René Descartes and the 'Cartesian waterfall' mindset",
    text: "In our modern industrialized world, the pace of change compels us to adapt quickly. Consequently, agile methodologies have...",
    date: "19 Février 2025",
    category: "Engineering",
    createdBy: "Written by Lotfi Ammar",
    lien: "https://www.linkedin.com/pulse/influence-john-locke-modified-agile-approach-contrast-ren%C3%A9-dzuue",
  },
  {
    image: Blog1,
    name: "The Shift from Full-Stack Development to AI Integration",
    text: "The landscape of IT and software development is undergoing a profound transformation. Traditionally, the full-stack...",
    date: "28 Février 2025",
    category: "Artifical Intelligence",
    createdBy: "Written by Lotfi Ammar",
    lien: "https://www.linkedin.com/pulse/shift-from-full-stack-development-ai-integration-new-paradigm-hhqde",
  },
  {
    image: Blog3,
    name: "The Influence of Nick Land and Curtis Yarvin on Agile Methodology in Software Development",
    date: "28 Mars 2025",
    category: "Engineering",
    text: "The Agile methodology, known for its iterative and adaptive approach to software development, has long been associated with flexibility...",
    createdBy: "Written by Lotfi Ammar",
    lien: "https://www.linkedin.com/pulse/influence-nick-land-curtis-yarvin-agile-methodology-software-wbbre",
  },
];
